import { BrowserRouter, Routes, Route, Link } from "react-router-dom"

// pages
import Home from "./pages/Home"
import Fileupload from "./pages/Fileupload"



function App() {
  return (
    <BrowserRouter>
      <nav>
        <h1>Klarety</h1>
        <Link to="/">Submit Report</Link>
        <Link to="/Fileupload">Upload File</Link>
      </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Fileupload" element={<Fileupload />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
